export enum IdbFallbackReason {
    /**
     * Fall back because this resolver, or this resolver on this data,
     * is not supported by Idb.
     */
    NotSupportedByIdb,

    /**
     * Item not found in IndexedDB (not synced offline yet)
     */
    NotFound,

    /**
     * Message has local unsynchronized changes (dirty)
     */
    Dirty,

    /**
     * IndexedDB database not available or not initialized
     */
    NoDatabase,

    /**
     * Request shape contains unsupported properties
     */
    UnsupportedShape,

    /**
     * Body doesn't satisfy required shape (e.g., HTML vs plaintext mismatch)
     */
    BodyShapeMismatch,
}
